import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { IdentityPoolService } from '~src/authentication/services/IdentityPoolService';
import { Messages } from '~src/codegen/Localize';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IServerUser } from '~src/userManagement/users/serverApi/types/IServerUser';
import { ISiteUser } from '~src/userManagement/users/serverApi/types/ISiteUser';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';

import { showIdentityPoolSelectionBasedActionDialog } from './IdentityPoolSelectionBasedAction';

export function addToIdentityPoolOnSiteUser(siteUser: ISiteUser): Promise<any> {
  return addToIdentityPool(siteUser, (identityPool: IIdentityPool) => IdentityPoolService.addToIdentityPoolOnSiteUser(siteUser, identityPool));
}

export function addToIdentityPoolOnServerUser(serverUser: IServerUser): Promise<IResult> {
  return addToIdentityPool(serverUser, (identityPool: IIdentityPool) => IdentityPoolService.addToIdentityPool(serverUser, identityPool));
}

function addToIdentityPool(user: IUser, myAction: (identityPool: IIdentityPool) => Promise<IResult>): Promise<IResult> {
  const userExistingPoolIds = new Set<string>(user.poolMemberships?.map((x) => x.identityPool.id));
  const poolsToAdd = IdentityPoolService.latestIdentityPools(true).filter((x) => !userExistingPoolIds.has(x.id));

  return showIdentityPoolSelectionBasedActionDialog(Messages.identityPools_AddToPoolAction_DialogTitle(),
    Messages.identityPools_AddToPoolAction_DialogConfirmButon(), Messages.identityPools_AddToPoolAction_DialogDescription({
      USER_DISPLAY_NAME: user.displayName
    }), poolsToAdd, false, myAction);
}
